import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sub-categories-quick-actions',
  template: require('./sub-categories-quick-actions.component.html')
})
export class SubCategoriesQuickActionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/sub-categories-quick-actions/sub-categories-quick-actions.component.ts